// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "form[data-v-6ab537d0]{padding:1.5em 1.5em 0}.divider[data-v-6ab537d0]{margin:0}.login-form[data-v-6ab537d0] label{display:block;margin-top:.75em}.pw-link[data-v-6ab537d0]{font-size:var(--body)}.login-btn[data-v-6ab537d0]{margin:1em 0}.reset-password[data-v-6ab537d0] .modal-container{left:auto;margin:auto;min-width:12em;width:79vw}.reset-password[data-v-6ab537d0] .modal-body{padding:1em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
